import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getRegion } from './get-region';

/** `POST /client/:cid/regions/:id/hubs {hub_id}`: other regions keep the hub. */
export const addHub = async (region_id: string, hub_id: string): Promise<any> => {
  await lpRequest('POST', clientPath(`/regions/${region_id}/hubs`), { body: { hub_id } });

  return getRegion(region_id);
};
